import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingRoutingModule } from './landing-routing.module';
import { LandingComponent } from './landing.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ApplicantDetailsComponent } from './applicant-details/applicant-details.component';
@NgModule({
  declarations: [LandingComponent, ApplicantDetailsComponent],
  imports: [CommonModule, SharedModule, LandingRoutingModule],
})
export class LandingModule {}
